module.exports = __webpack_public_path__ + "static/img/5-2.de6e808.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/5-2.jpg
// module id = L1ki
// module chunks = 0